import { CCard, CCardBody, CCol, CCardHeader, CRow } from '@coreui/react'
import {
    CChartBar,
    CChartDoughnut,
    CChartLine,
    CChartPie,
    CChartPolarArea,
    CChartRadar,
} from '@coreui/react-chartjs'
import { DocsCallout } from 'src/components';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Flex, Input, Tabs, Upload, Select, Spin, Checkbox, Collapse, Modal } from 'antd';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { apiUrls } from '../../apiUrls.js';
import Program from "../../components/Program.js";
import { useNavigate } from 'react-router-dom';
import { UnlockOutlined, LockOutlined, EditOutlined, SearchOutlined, DollarOutlined, WalletFilled } from '@ant-design/icons';
import AmountFormat from "../../components/AmountFormat.js";
import InputNumberFormat from "../../components/InputNumberFormat.js";
import DatePicker, { utils } from '@hassanmojab/react-modern-calendar-datepicker';
import { UploadOutlined } from '@ant-design/icons';
import jquery from 'jquery';
import HideSidebarInMobileMode from "../../components/HideSidebarInMobileMode.js";

const { Option } = Select;

const baseURL = apiUrls.baseURL;

const MyBills = () => {

    const [data, setData] = useState([]);
    const [billModel, setBillModel] = useState({});
    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [id, setId] = useState(0);
    const [count, setCount] = useState(0);
    const [filter, setFilter] = useState({ skip: 0, limit: 20, data: {} });
    const navigate = useNavigate();
    const [reload, setReload] = useState(false);

    useEffect(() => {
        fetchData()
    }, [reload])

    useEffect(() => {
        const loadNextPage = () => {
            const isNearBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 200;
            const hasMore = data.length < count;

            if (isNearBottom && hasMore && !loading && !loadingMore) {
                setLoadingMore(true);
                setFilter((current) => ({ ...current, skip: current.skip + 1 }));
                setReload(true);
            }
        };

        window.addEventListener('scroll', loadNextPage);
        loadNextPage();
        return () => window.removeEventListener('scroll', loadNextPage);
    }, [data, count, loading, loadingMore, filter.skip]);

    const fetchData = async () => {
        if (!loadingMore) setLoading(true);

        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.post(`${baseURL}/bill/getmybills`, filter, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            var result = response.data.data;
            result.items.map(item => {
                item.key = item.id
            })
            setCount(result.count)
            setData((current) => filter.skip === 0 ? result.items : [...current, ...result.items]);
            setLoading(false);
            setReload(false)
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setLoading(false);
            setReload(false)
        } finally {
            setLoading(false);
            setLoadingMore(false);
            setReload(false)
        }
    };

    const refreshBills = () => {
        setData([]);
        setFilter((current) => ({ ...current, skip: 0 }));
        setLoading(true);
        setLoadingMore(false);
        setReload(true);
    };

    const pay = async (id, amount) => {
        const token = localStorage.getItem('damavandclub-token')
        try {
            var response = await axios.post(`${baseURL}/payment/initilize`, { billId: id, amount: amount }, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            var result = response.data.data;

            const newWindow = window.open('', '_blank');

            if (newWindow) {
                newWindow.location.href = result;
            } else {
                // در صورتی که پیش باز کردن پنجره مسدود شده باشد
                window.location.href = result;
            }

        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            toast.error(error.response.data.Msg, {
                position: 'bottom-right',
                autoClose: 6000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                //className: 'custom-toast',
                pauseOnHover: true,
                draggable: true,
            });
        } finally {
            refreshBills();
        }
    };

    return (
        <div className="my-bills-page">
            <HideSidebarInMobileMode />
            {loading && !loadingMore ? <div className="my-wallet-transactions-loading"><Spin size="large" /></div> : data.length > 0 ?
                <div className="my-wallet-transaction-grid">
                    {data.map((record, index) => (
                        <article className={`my-wallet-transaction-card my-bill-card ${record.isPaid ? 'is-paid' : 'is-unpaid'}`} key={record.key || record.id || index}>
                            <div className="my-wallet-transaction-card-top">
                                <span className={`my-bill-status ${record.isPaid ? 'is-paid' : 'is-unpaid'}`}>{record.isPaid ? 'پرداخت شده' : 'پرداخت‌نشده'}</span>
                                <span className="my-wallet-transaction-index">#{index + 1}</span>
                            </div>
                            <div className="my-wallet-transaction-amount-row">
                                <div className="my-wallet-transaction-amount-label">مبلغ قبض</div>
                                <div className="my-wallet-transaction-amount"><AmountFormat amount={record.amount} /><span>ریال</span></div>
                            </div>
                            <div className="my-wallet-transaction-details">
                                {record.typeTitle ? <div><span>نوع قبض</span><strong>{record.typeTitle}</strong></div> : null}
                                {record.creatorName ? <div><span>ایجادکننده</span><strong>{record.creatorName}</strong></div> : null}
                                {record.persianPayDateDeadLine ? <div><span>مهلت پرداخت</span><strong>{record.persianPayDateDeadLine}</strong></div> : null}
                                {record.persianPayDate ? <div><span>تاریخ پرداخت</span><strong>{record.persianPayDate}</strong></div> : null}
                                {record.description ? <div><span>توضیحات</span><strong>{record.description}</strong></div> : null}
                            </div>
                            {record.photoUrl ? <a className="my-bill-photo-link" href={record.photoUrl} rel="noreferrer" target="_blank">
                                <img src={record.photoUrl} alt="تصویر قبض" />
                                <span>مشاهده تصویر قبض</span>
                            </a> : <div className="my-bill-no-photo">تصویری برای این قبض ثبت نشده</div>}
                            {!record.isPaid ? <div className="my-bill-card-footer">
                                {record.loadingPayment ? <Spin size="small" /> : <Button type="primary" className="my-bill-pay-action" icon={<DollarOutlined />} onClick={() => {
                                    const updateItem = data.map(item => item.id === record.id ? { ...item, loadingPayment: true } : item);
                                    setData(updateItem);
                                    pay(record.id, record.amount);
                                }}>پرداخت قبض</Button>}
                            </div> : null}
                        </article>
                    ))}
                </div> : !loading ? <div className="my-wallet-transactions-empty">قبضی برای نمایش وجود ندارد</div> : null}
            {loadingMore && <div className="members-wallet-load-more"><Spin size="small" /></div>}
            <div className="members-wallet-total">
                <span>تعداد کل قبض‌ها</span>
                <strong>{count}</strong>
            </div>
        </div>
    )
}

export default MyBills
